import { render } from "./UsersListing.vue?vue&type=template&id=0010defa"
import script from "./UsersListing.vue?vue&type=script&lang=js"
export * from "./UsersListing.vue?vue&type=script&lang=js"
script.render = render

export default script